module.exports = __webpack_public_path__ + "static/media/search_origin.e4966c89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/search_origin.svg
// module id = 644
// module chunks = 0